module.exports = __webpack_public_path__ + "img/9788934989448.da094f92.jpg";